export default "__VITE_ASSET__DmRld$hT__"